const {
  FRONTEND_CAMPAIGN_END_BUFFER,
  IMAGE_TEMPLATE_FIELDS,
} = require('./consts');

const getClosestCampaignStateTimestamp = (campaigns) =>
  campaigns
    ?.flatMap(({ availableFrom, availableUntil }) => [
      availableFrom && new Date(availableFrom).getTime(),
      availableUntil &&
        new Date(availableUntil).getTime() - FRONTEND_CAMPAIGN_END_BUFFER,
    ])
    ?.filter((timestamp) => timestamp > Date.now())
    ?.reduce(
      (min, timestamp) => (timestamp < (min ?? Infinity) ? timestamp : min),
      undefined,
    );

const isCampaignAvailable = (availableFrom, availableUntil) =>
  new Date(availableFrom).getTime() < Date.now() &&
  new Date(availableUntil).getTime() - FRONTEND_CAMPAIGN_END_BUFFER >
    Date.now();

const copyLootpackWithCampaignImages = (campaigns) => (loot) => {
  const campaign = campaigns[loot._id];

  if (!campaign) {
    return loot;
  }
  const { imageTemplate } = campaign;
  const newLoot = { ...loot };
  IMAGE_TEMPLATE_FIELDS.forEach((fieldName) => {
    if (imageTemplate[fieldName]) {
      newLoot[fieldName] = imageTemplate[fieldName];
    }
  });
  return newLoot;
};

const copyPurchaseLootpackWithImageCampaign = (campaigns) => (purchase) => {
  if (!purchase.loot) {
    return purchase;
  }
  return {
    ...purchase,
    loot: copyLootpackWithCampaignImages(campaigns)(purchase.loot),
  };
};

module.exports = {
  getClosestCampaignStateTimestamp,
  isCampaignAvailable,
  copyLootpackWithCampaignImages,
  copyPurchaseLootpackWithImageCampaign,
};
